module.exports = __webpack_public_path__ + "img/ask.eda42488.svg";